<div class="row">
    <div class="col-12">
        <div class="search-by-location">
            <mat-form-field class="mat-form-field-fluid">
                <input matInput type="text" (keydown.enter)="$event.preventDefault()"
                    [placeholder]="'GENERAL.PLACEHOLDER.SEARCH_BY_CITY' | translate" autocorrect="off" autocapitalize="off"
                    spellcheck="off" #search/>
                <mat-icon
                        matSuffix
                        class="cursor-pointer"
                        (click)="$event.stopPropagation();"
                        container="body"
                        [ngbPopover]="'TOOLTIP.HOUSE.LOCATE.DESCRIPTION' | translate"
                        [popoverTitle]="'TOOLTIP.HOUSE.LOCATE.TITLE' | translate">help
                </mat-icon>
            </mat-form-field>
            <mat-checkbox [formControl]="useAsAddressControl">
                Use as property address
            </mat-checkbox>
        </div>
    </div>
    <div class="col-12">
        <agm-map [latitude]="centerLat$|async" [longitude]="centerLng$|async" [zoom]="zoom" [usePanning]="true"
            [clickableIcons]="false" 
            (mapReady)="onMapReady($event)">
            <agm-map-type-control></agm-map-type-control>
            <button type="button" id="DrawShape" class="btn btn-white ml-3 mt-1 p-0 map-button map-draw-button"
                style="width: 30px; height: 26px" [hidden]="!(drawAllowed$|async)"
                [class.active]="drawActive$|async"
                [title]="(drawActive$|async) ? 'Stop drawing' : 'Draw land boundary'"
                (click)="onToggleDraw()">
                <mat-icon inline>gesture</mat-icon>
            </button>
            <button type="button" id="DeleteShape" class="btn btn-white ml-3 mt-1 p-0 map-button"
                style="width: 30px; height: 26px" (click)="onDeleteShape()">
                <mat-icon inline>remove_circle_outline</mat-icon>
            </button>
            <ng-container *ngIf="marker$|async as marker">
                <agm-marker *ngIf="marker"
                    [latitude]="marker.lat"
                    [longitude]="marker.lng"
                    [markerDraggable]="true">
                </agm-marker>
            </ng-container>
        </agm-map>
    </div>
</div>
<div class="row mt-4" *ngIf="form.controls.boundary_type_id.value == 3">
    <div class="col-lg-12 mb-4" style="display: flex; justify-content: end;">
        <button mat-raised-button type="button" class="btn btn-primary" color="primary" (click)="addPoint()">
            Add a point
        </button>
    </div>

    <div class="col-lg-12 mb-4">
        <table class="table">
            <thead>
                <tr>
                    <th>
                        No
                    </th>
                    <th>
                        X
                    </th>
                    <th>Y</th>
                    <th>Length ({{staticUnitLengthName}})</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of (datasource|async); let i = index;">
                    <th>
                        {{i + 1}}
                    </th>
                    <td>
                        <ng-container >
                            <input type="text" [value]="item.point.lat" (focusout)="onFocusOut($event, 'lat', item.point)">
                        </ng-container>
                    </td>
                    <td>
                        <ng-container >
                            <input type="text" [(ngModel)]="item.point.lng" (focusout)="onFocusOut($event, 'lng', item.point)">
                        </ng-container>
                    </td>
                    <td>
                        {{item.length  
                            ? staticUnit == 2 ? item.length * imperial_length : item.length
                            : 'N/A'}}
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>
                        Total ({{staticUnitName}})
                    </th>
                    <td colspan="3">
                        <ng-container *ngIf="(area$|async) as area">
                            <ng-container *ngIf="area != null">
                                {{area.toPrecision(6)}} {{staticUnitName}}
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!(area$|async)">
                            N/A
                        </ng-container>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<div class="row mt-4" [formGroup]="form">
    <div class="col-lg-4 kt-margin-bottom-20-mobile">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['country_id']">
            <mat-select [placeholder]="'Country'" formControlName="country_id" (selectionChange)="selectCountry()">
                <mat-option *ngFor="let country of allCountries" [value]="country.id">{{country.name}}</mat-option>
            </mat-select>
            <mat-hint [formFieldHintState]="form.controls['country_id']">
                Country <span>required</span>
            </mat-hint>
            <mat-error>
                Country <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>
    <div class="col-lg-4 kt-margin-bottom-20-mobile">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['city_id']">
            <mat-select [placeholder]="'City'" formControlName="city_id">
                <mat-option [value]="0">Not Applicable</mat-option>
                <mat-option *ngFor="let city of cityOfCountry" [value]="city.id">{{city.name}}</mat-option>
            </mat-select>
            <mat-hint [formFieldHintState]="form.controls['city_id']">
                City <span>required</span>
            </mat-hint>
            <mat-error>
                City <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>
    <div class="col-lg-4 kt-margin-bottom-10-mobile">
        <mat-form-field class="mat-form-field-fluid">
            <input matInput [placeholder]="'Zipcode/Postalcode'" formControlName="zip_code" />
        </mat-form-field>
    </div>

    <div class="col-lg-4 kt-margin-bottom-10-mobile">
        <mat-form-field class="mat-form-field-fluid">
            <mat-select [placeholder]="'Location Grade'" formControlName="location_grade_id">
                <mat-option *ngFor="let grade of grades" [value]="grade.id">{{grade.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-lg-4">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['name']">
            <input matInput placeholder="Land Parcel ID" formControlName="name" type="text">
            <mat-hint [formFieldHintState]="form.controls['name']">
                Name <span>required</span>
            </mat-hint>
            <mat-error>
                Name <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>

    <div class="col-lg-4">
        <mat-form-field class="mat-form-field-fluid">
            <mat-select placeholder="Property Sub-Type" formControlName="property_type_id">
                <mat-option *ngFor="let propertyType of filteredPropertySubTypes"
                    [value]="propertyType.id">{{propertyType.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-lg-12 kt-margin-b-10-mobile">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['address']">
            <textarea matInput rows="4" [placeholder]="'Address'" formControlName="address"></textarea>
            <mat-hint [formFieldHintState]="form.controls['address']">
                Address <span>required</span>
            </mat-hint>
            <mat-error>
                Address <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>
    <div class="col-lg-12 kt-margin-b-10-mobile">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['location_surrounding']">
            <textarea matInput rows="4" [placeholder]="'Location and Surroundings Description'"
                formControlName="location_surrounding"></textarea>
            <mat-hint [formFieldHintState]="form.controls['location_surrounding']">
                Description <span>required</span>
            </mat-hint>
            <mat-error>
                Description <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>

    <div class="col-12">
        <div class="row">
            <div class="col-6">
                Add coordinates of each boundary cover or pivot point of the land parcel ?
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-lg-6">
                <mat-radio-group formControlName="boundary_type_id">
                    <mat-radio-button [value]="1">No</mat-radio-button>
                    <mat-radio-button [value]="2">Draw</mat-radio-button>
                    <mat-radio-button [value]="3">Write Down</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>

    <div class="col-lg-6 mt-2">
        <mat-form-field class="mat-form-field-fluid">
            <mat-select placeholder="Coordinate Reference System" formControlName="coordinate_reference_system_id">
                <mat-option *ngFor="let coordinateReferenceSystem of coordinateReferenceSystems"
                    [value]="coordinateReferenceSystem.id">{{coordinateReferenceSystem.name}}</mat-option>
            </mat-select>
            <mat-icon matSuffix class="cursor-pointer" (click)="$event.stopPropagation();" container="body"
                [ngbPopover]="'TOOLTIP.LAND_PARCEL.CRS.DESCRIPTION' | translate">help
            </mat-icon>
        </mat-form-field>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="form-group row section-margin-top-60 tag-custom-padding-16_25">
            <kt-land-area-list class="col-md-12" [landAreaComponentListSubject]="landAreaComponentListSubject"
                [landAreaSubject]="landAreaSubject">
            </kt-land-area-list>
            <div class="col-12">
                <div class="mad-container">
                    <mat-error 
                        errorStateWithValidation
                        [hasFormError]="hasFormErrors$|async"
                        [isInvalid]="landAreaComponentListSubject.value.length === 0">
                        Required
                    </mat-error>
                </div>
            </div>
        </div>
    </div>
</div>